'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Dialog = require('./Dialog.js');
var DialogTitle = require('./DialogTitle.js');
var DialogActions = require('./DialogActions.js');
var DialogContent = require('./DialogContent.js');
var ObjectHelper = require('../../../common/ObjectHelper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ConfirmationDialog = function ConfirmationDialog(_ref) {
  var open = _ref.open,
      title = _ref.title,
      children = _ref.children,
      leftButton = _ref.leftButton,
      rightButton = _ref.rightButton,
      fullWidth = _ref.fullWidth,
      dialogTitleProps = _ref.dialogTitleProps,
      dialogContentProps = _ref.dialogContentProps,
      dialogActionProps = _ref.dialogActionProps,
      props = objectWithoutProperties(_ref, ["open", "title", "children", "leftButton", "rightButton", "fullWidth", "dialogTitleProps", "dialogContentProps", "dialogActionProps"]);

  var newProps = _objectSpread({
    open: open,
    fullWidth: fullWidth
  }, props);

  if (!props.fullScreen) {
    newProps.PaperProps = {
      style: {
        borderRadius: 30
      }
    };
  }

  return React__default["default"].createElement(Dialog, _objectSpread({}, newProps), React__default["default"].createElement(DialogTitle, _objectSpread({}, dialogTitleProps), title), ObjectHelper.isPresent(children) && React__default["default"].createElement(DialogContent, _objectSpread({}, dialogContentProps), children), React__default["default"].createElement(DialogActions, _objectSpread({}, dialogActionProps), ObjectHelper.isPresent(leftButton) && leftButton, ObjectHelper.isPresent(rightButton) && rightButton));
};

ConfirmationDialog.defaultProps = {
  fullWidth: true
};

module.exports = ConfirmationDialog;
